import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  allDoctorsSelector,
  fetchMedicationsAsync,
  fetchPharmaciesAsync,
  fetchPrimaryDoctorAsync,
  fetchSpecialistsAsync,
  handleLoadingState,
  saveMedicationsAsync,
  medicationsSelector,
  pharmaciesSelector,
  searchFdaMedicationsAsync,
} from '../../../lib/dataLayer';
import { isLoadingSelector } from '../../../store/app/selectors';
import MedicationPage from '../components/MedicationPage';

const fetchDataAsync = () => dispatch => {
  return dispatch(fetchPrimaryDoctorAsync())
    .then(() => dispatch(fetchSpecialistsAsync()))
    .then(() => dispatch(fetchPharmaciesAsync()))
    .then(() => dispatch(fetchMedicationsAsync()));
};

const mapStateToProps = state => ({
  medications: medicationsSelector(state),
  pharmacies: pharmaciesSelector(state),
  doctors: allDoctorsSelector(state),
  isLoading: isLoadingSelector(state),
});

const mapDispatchToProps = {
  onMount: () => handleLoadingState(fetchDataAsync),
  onSave: saveMedicationsAsync,
  onSearch: searchFdaMedicationsAsync,
  onContinue: () => push('/settings'),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MedicationPage);



// WEBPACK FOOTER //
// ./src/modules/MedicationPage/containers/MedicationPageContainer.js